import React, { useEffect, useState } from 'react'
import LandingPage from './LandingPage'
import { url } from '../../Utilities/url'
import axios from 'axios'
const Policy = () => {
    const [data, setData] = useState()
    const fetchData = async()=>{
        try{
            const res = await axios.post(url.apiUrl+'public/page/privacy-policy', {
                headers:{
                   
                   'company-code':'D11'
                }
            })
            setData(res?.data?.item?.description)
        }
        catch(error){
            console.log(error)
        }
    }
    useEffect(()=>{
        fetchData()
    },[])
  return (
    <LandingPage>
        <div style={{paddingTop:'7rem', paddingBottom:'1rem' , display:'flex',flexDirection:'column',  justifyContent:'center', alignItems:'center', backgroundColor:'var(--content-color)'}}>
            <h4>Privacy Policy</h4>
            <div className='col-10' dangerouslySetInnerHTML={{ __html: data }} style={{color:"var(--color-heading)"}}>

            </div>
        </div>
    </LandingPage>
  )
}

export default Policy